import { ENDPOINTS } from "./Endpoints";
import { POST } from "./Requests";

export default function hideNode(node) {
    return POST(ENDPOINTS.hideNode, { node : node })
}
